import { useState, useEffect, useMemo } from 'react'
import { pathsApi } from '../stores/useTrainingStore'

/**
 * Отфильтровать «Мой адаптационный трек» у того, кто на трек не записан.
 *
 * Пункт виден только тому, у кого есть активные записи (Наталья 2026-08-02):
 * раньше он висел на всей роли, и человек, давно прошедший адаптацию, открывал
 * пустую страницу. Признак — не роль, а факт записи, поэтому спрашиваем данные,
 * а не каталог модулей.
 *
 * 2026-08-21: пункт переехал из секции «Онлайн-менеджер» в «Личный кабинет».
 * Трек адаптации есть у партнёр-менеджера и любого другого отдела, а привязка к
 * чужой секции прятала его от всех, кроме онлайн-менеджеров. Хук поэтому
 * принимает список пунктов, а не знает конкретную секцию.
 *
 * Принимает employeeId, а НЕ user-объект: в Layout.jsx `effectiveUser`
 * объявлен ниже места вызова и обращение к нему роняет весь Layout (TDZ), а с
 * ним и любую страницу. Вызывающий передаёт `auth.user?.employee_id` — для
 * трека разницы нет, превью «как другая роль» подменяет только роль.
 *
 * Ошибку глушим: меню не должно падать из-за необязательного запроса, при сбое
 * пункт просто останется скрытым.
 */
export function useMyTrackNav(employeeId, items) {
    const [hasTrack, setHasTrack] = useState(false)

    useEffect(() => {
        if (!employeeId) { setHasTrack(false); return }
        let cancelled = false
        pathsApi.my(employeeId)
            .then(data => { if (!cancelled) setHasTrack(Array.isArray(data) && data.length > 0) })
            .catch(() => { if (!cancelled) setHasTrack(false) })
        return () => { cancelled = true }
    }, [employeeId])

    return useMemo(
        () => hasTrack ? items : items.filter(i => i.to !== 'my-track'),
        [hasTrack, items],
    )
}
